import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_PROGRAM_OPTIONS_DETAILS_ACTION_TYPE } from '../actions';

const initialState = {};

const loanProgramOptionsDetails = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_PROGRAM_OPTIONS_DETAILS_ACTION_TYPE.SET_LOAN_PROGRAM_OPTIONS_DETAILS:
      return _.isObject(payload) ? payload : state;

    case LOAN_PROGRAM_OPTIONS_DETAILS_ACTION_TYPE.RESET_LOAN_PROGRAM_OPTIONS_DETAILS:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanProgramOptionsDetails;
